<div class="pdf-viewer-dialog">
  <div mat-dialog-title class="pdf-header">
    <mat-tab-group *ngIf="data.tabs.length > 1" class="pdf-tabs"
                   [selectedIndex]="activeIndex"
                   (selectedIndexChange)="onTabChange($event)">
      <mat-tab *ngFor="let t of data.tabs" [label]="t.label"></mat-tab>
    </mat-tab-group>
    <span class="pdf-title" *ngIf="data.tabs.length === 1">{{ data.tabs[0].label }}</span>

    <div class="pdf-header-actions">
      <button mat-icon-button (click)="zoomOut()" matTooltip="Zoom out" [disabled]="zoom <= 0.5">
        <mat-icon>remove</mat-icon>
      </button>
      <span class="zoom-label">{{ zoom * 100 }}%</span>
      <button mat-icon-button (click)="zoomIn()" matTooltip="Zoom in" [disabled]="zoom >= 3">
        <mat-icon>add</mat-icon>
      </button>
      <button mat-icon-button (click)="onDownload()" matTooltip="Download" [disabled]="!activeState?.blob">
        <mat-icon>download</mat-icon>
      </button>
      <button mat-icon-button (click)="onClose()" matTooltip="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <mat-dialog-content class="pdf-content">
    <div *ngIf="activeState?.loading" class="pdf-loading">
      <mat-spinner diameter="48"></mat-spinner>
    </div>
    <pdf-viewer
      *ngIf="displaySrc && !activeState?.loading"
      [src]="displaySrc"
      [render-text]="true"
      [original-size]="false"
      [zoom]="zoom"
      [show-all]="true"
      class="pdf-viewer">
    </pdf-viewer>
  </mat-dialog-content>
</div>
